/**
 * Cheap, order-sensitive signature of a message list.
 *
 * Used to decide when the frozen `renderedMessages` snapshot must resync with the
 * live thread. A count-only comparison misses same-length divergences (reordered
 * messages, streamed placeholder replaced by final content, optimistic id swapped
 * for the server id) — those then stay wrong on screen until a page refresh.
 *
 * Includes content length rather than full content to keep it O(n) with tiny strings.
 */
export function messagesSignature(messages) {
  if (!messages || messages.length === 0) return ''
  return messages
    .map((m) => `${m?.id ?? ''}:${m?.timestamp ?? ''}:${m?.role ?? ''}:${m?.content?.length ?? 0}`)
    .join('|')
}
